import { bindable, bindingMode, containerless } from 'aurelia-framework';

@containerless()
export class OrgChart {
    @bindable({ defaultBindingMode: bindingMode.oneWay }) items: any[];
    @bindable({ defaultBindingMode: bindingMode.oneWay }) currentItemId: string;
    @bindable({ defaultBindingMode: bindingMode.oneWay }) removeNodeFn: (item) => Promise<any>;
    @bindable({ defaultBindingMode: bindingMode.oneWay }) addNodeFn: (item) => Promise<any>;
}